import React from 'react'
import './RecentWorks.modules.css'
import { Link } from 'react-router-dom'
function RecentWorks() {
    const imgArr = [
        {
            src: 'images/projects/statik.png',
            title: 'Statik',
            desc: 'An IPFS-based version control CLI tool with static file hosting features',
            link: 'https://github.com/SANTHOSH17-DOT/statik/'
        },
        {
            src: 'images/projects/hodl.png',
            title: 'HODL',
            desc: 'Hold On for Dear Life is a time lock wallet to which users can send their crypto and set a HODL time',
            link: 'https://github.com/SANTHOSH17-DOT/HODL'
        },
        {
            src: 'images/projects/graybox.webp',
            title: 'GrayBox',
            desc: 'GrayBox aims to solve this problem by providing a decentralized cloud storage solution for users and organizations that is simple to use and have peace of mind for their data. I primarily worked on the blockend where I used the Graph protocol to index data from the blockchain.',
            link: 'https://devfolio.co/projects/graybox-e74c'
        },
        {
            src: 'images/projects/zipbomb.png',
            title: 'Are You Bombed',
            desc: 'A Golang application which can generate flat and nested zip bombs and serve them using Fiber HTTP web framework.',
            link: 'https://github.com/SANTHOSH17-DOT/are-you-bombed'
        },
        {
            src: 'images/projects/attackVectorsSuite.jpg',
            title: 'Attack Vectors Suite',
            desc: 'This opensource repository contains a collection of cybersecurity attack vectors. I firmly believe that the best way to learn something is to do it & all my experiments with a particular attack vector have been documented in this repo.',
            link: 'https://github.com/SANTHOSH17-DOT/attack-vectors-suite'
        },
        {
            src: 'images/projects/lynx.webp',
            title: 'Lynx NITT',
            desc: 'Lynx is a centralized platform for all Councils, Clubs, Student Bodies, and Fests to communicate directly to NITTians without the clutter present in Social Media, enabling effective and immediate communication.\n It was a project under Spider R&D. I majorly worked with the backend and the devops team.',
            link: 'https://play.google.com/store/apps/details?id=org.spider.nittapp&pcampaignid=web_share'
        },
        {
            src: 'images/projects/gym-pool.webp',
            title: 'Gym & Pool Registration Portal NITT',
            desc: 'Developed a registration portal for the institute gym and swimming pool. I work on both the backend and DevOps side of the project. We considered real-time streaming of available slots a challenge and handled the race condition when users submitted their responses. We used GRPC to build the backend and implemented microservices interactions.',
            link: 'https://gym-pool.spider-nitt.org/'
        }
        // {
        //     src: 'images/projects/colorTiles.png',
        //     title: 'Color Tiles',
        //     desc: 'A game which baffles your mind',
        //     link: 'https://santhosh17-dot.github.io/Color-tiles/'
        // },
        // {
        //     src: 'images/projects/piano.png',
        //     title: 'Piano',
        //     desc: 'Virtual piano',
        //     link: 'https://santhosh17-dot.github.io/piano/'
        // },
        // {
        //     src: 'images/projects/schedulePlanner.png',
        //     title: 'Schedule Planner',
        //     desc: 'Schedule planner to make your life easier',
        //     link: 'https://santhosh17-dot.github.io/Schedule-planner/'
        // },
        // {
        //     src: 'images/projects/scientificCalculator.png',
        //     title: 'Scientific Calculator',
        //     desc: 'Scientific calculator',
        //     link: 'https://santhosh17-dot.github.io/Scientific-calculator/'
        // }
        // , {
        //     src: 'images/projects/screenRecord.png',
        //     title: 'Screen Recorder',
        //     desc: 'It is a screen recorder with video downloading and screenshot options',
        //     link: 'https://santhosh17-dot.github.io/screen-recorder/'
        // },
        // {
        //     src: 'images/projects/spaceInvader.png',
        //     title: 'Space Invader',
        //     desc: 'A game which gives you thrilling space adventure',
        //     link: 'https://santhosh17-dot.github.io/space-invader/'
        // },
        // {
        //     src: 'images/projects/spaceRunner.png',
        //     title: 'Pro Runner',
        //     desc: 'A game which test your reflex',
        //     link: 'https://santhosh17-dot.github.io/Space-runner/'
        // },
        // {
        //     src: 'images/projects/prodigyWeb.png',
        //     title: 'Prodigy Website',
        //     desc: 'Website for Prodigy NITT',
        //     link: 'https://santhosh17-dot.github.io/prodigy-website/'
        // }
    ]
    return (
        <div id='recentWorks'>
            <div id='titleW'>
                Projects
            </div>
            <div className="imgs-container">
                {imgArr.map(img => (
                    <div key={img.src} className=" img-container">
                        <img loading='lazy'src={img.src} className="card-img-top" alt=" " />
                        <div className="card-body">
                            <h5 className="card-title"><b>{img.title}</b></h5>
                            <p className="card-text">{img.desc}</p>
                            <a href={img.link} className="btn view-btn"target='_blank'rel="noreferrer">View</a>
                        </div>
                    </div>
                ))}


            </div>
            <div className='arrowsW'>
                <Link to='/'><i className="fas fa-chevron-left workL"></i></Link>


            </div>
        </div>
    )
}

export default RecentWorks
